import React, { useContext } from 'react';
import { GlobalFiltersContext } from '../../GlobalFiltersContext';
import { TimedFetch } from './use-cases/TimedFetch';

export const BookFilter = ({}) => {
  const {
    loadingGlobal,
    bookVisible,
    bookSearchValue,
    bookLoading,
    bookLoaded,
    bookError,
    bookData,
    bookRI,
    setBookVisible,
    setBookSearchValue,
    setBookLoading,
    setBookLoaded,
    setBookError,
    setBookData,
    setBookRI,
    updateData,
    setPage
  } = useContext(GlobalFiltersContext);

  return (
    <TimedFetch
      segment="book"
      placeholder="Livros"
      loadingGlobal={loadingGlobal}
      visible={bookVisible}
      searchValue={bookSearchValue}
      loading={bookLoading}
      loaded={bookLoaded}
      error={bookError}
      data={bookData}
      ri={bookRI}
      setVisible={setBookVisible}
      setSearchValue={setBookSearchValue}
      setLoading={setBookLoading}
      setLoaded={setBookLoaded}
      setError={setBookError}
      setData={setBookData}
      setRI={setBookRI}
      updateData={updateData}
      setPage={setPage}
      fetchOnMount={true}
    />
  );
};
